import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

function AxisHorizontal({ items, width, updateLeftOffset, getLabel }) {
  const [contentWidth, setContentWidth] = useState(0);
  const containerRef = useRef(null);
  const rotationDegrees = -45;
  const rads = (Math.PI / 180) * rotationDegrees;

  const getX = (i) => width * ((i + 0.5) / items.length);
  const getOffset = (w) => Math.abs(w * Math.cos(rads));

  useEffect(() => {
    const els = containerRef.current.getElementsByClassName("label");
    const elArr = Array.from(els);
    const widths = elArr.map((x) => x.offsetWidth);
    const cWidth = widths.reduce((a, b) => Math.max(a, b), 0);
    const leftOffsets = widths.map((x, i) => getX(i) - getOffset(x));
    const leftOffset = leftOffsets.reduce((a, i) => Math.min(a, i), 0);

    setContentWidth(cWidth);
    updateLeftOffset(Math.abs(leftOffset));
  }, [items, width]);

  return (
    <div className="tw-text-2xs tw-relative tw-flex">
      <div
        ref={containerRef}
        className="tw-opacity-0 tw-absolute tw-overflow-hidden"
      >
        {items.map((x) => (
          <div key={x.key} className="tw-h-1 label tw-inline-block">
            {getLabel(x)}
          </div>
        ))}
      </div>

      <div
        style={{ height: Math.abs(contentWidth * Math.sin(rads)) }}
        className="tw-w-full tw-h-0"
      >
        {items.map((x, i) => (
          <div
            key={x.key}
            style={{
              right: `${width - getX(i)}px`,
              transform: `rotate(${rotationDegrees}deg)`,
              width: `${contentWidth}px`,
            }}
            className="tw-absolute tw-select-none tw-whitespace-no-wrap tw-top-0 tw-text-right tw-overflow-visible tw-origin-right"
          >
            <div className="tw-transform tw-origin-right tw-opacity-70 hover:tw-opacity-100">
              <span
                data-tooltip-follow-mouse="true"
                data-tooltip-class="plot-tooltip"
                data-tooltip={`${x.key}: ${x.title || x.value}`}
              >
                {getLabel(x)}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="tw-flex-grow" />
    </div>
  );
}

AxisHorizontal.propTypes = {
  width: PropTypes.number.isRequired,
  getLabel: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateLeftOffset: PropTypes.func.isRequired,
};

AxisHorizontal.defaultProps = {};

export default AxisHorizontal;
